import { createApp } from 'vue'
import * as Sentry from '@sentry/vue'
import VueCookies from 'vue-cookies'
import VueScreen from 'vue-screen'
import BaseToast from '@emcd-shared/toasts'
import { AnalyticsService } from '@emcd-shared/analytics-service'
import authApiPlugin from '@/packages/auth-service/plugins/authApiPlugin'
import gtm from '@/app/gtm/index'
import ApiService from '@/shared/services/api.service'
import '@/app/plugins/Vee-validate/validator'
import phoneMask from '@/shared/lib/directives/phoneMask'
import OnlyNumbers from '@/shared/lib/directives/onlyNumbers'
import noSpecialCharacters from '@/shared/lib/directives/noSpecialCharacters'
import CustomApiService from '@/widgets/SendToEmail/services/api'
import CONFIG from '@/app/config/config'
import i18n from '@/app/i18n'
import App from '@/app/index.vue'

import router from '@/app/router'
import '@/app/middleware/index'
import store from '@/app/store'
import customApiPlugin from '@/app/plugins/customApiPlugin'
import b2bApiClient from '@/shared/api/b2b-client'

const app = createApp(App)

Sentry.init({
  app,
  dsn: CONFIG.SENTRY_DSN,
  release: CONFIG.VERSION,
  environment: CONFIG.ENVIRONMENT,
  debug: CONFIG.SENTRY_DEBUG === 'true',
  integrations: [Sentry.browserTracingIntegration({ router })],
  tracePropagationTargets: ['localhost', CONFIG.AUTH_URL],
  tracesSampleRate: 1.0,
  trackComponents: true,
  hooks: ['mount', 'update', 'destroy'],
  // beforeSend: function (event, hint) {
  //   const error = hint.originalException
  //   if (
  //     error?.name?.startsWith('Custom:') ||
  //     error?.name?.startsWith('Not described:')
  //   ) {
  //     event.fingerprint = [error.name]
  //   }
  //   return event
  // },
})

AnalyticsService.initAntiFraud()

// Directives
app.directive('phone-mask', phoneMask)
app.directive('only-numbers', OnlyNumbers())
app.directive('noSpecialCharacters', noSpecialCharacters)

app
  .use(router)
  .use(store)
  .use(VueCookies, { expires: '30d', path: '/' })
  .use(i18n)
  .use(BaseToast)
  .use(authApiPlugin, {
    ApiService,
    initAuthGuard: true,
  })
  .use(customApiPlugin, {
    CustomApiService,
  })
  .use(VueScreen, {
    grid: {
      xs: 576,
      sm: 768,
      md: 1024,
      lg: 1200,
    },
  })
// Fetch partner info once when access token becomes available
let __partnerInfoFetched = false
store.watch(
  (state) => state?.auth?.access_token,
  async (token) => {
    if (__partnerInfoFetched) return
    if (!token) return
    try {
      await store.dispatch('partner/fetchPartnerInfo')
      __partnerInfoFetched = true
    } catch (e) {
      AnalyticsService.addBreadcrumb(
        'PartnerInfo',
        'Failed to fetch partner info on init'
      )
    }
  },
  { immediate: true }
)

if (process.env.NODE_ENV !== 'development') {
  app.use(gtm)
}

b2bApiClient.init(app)

app.mount('#app')

export default app
